import NiceModal from "@ebay/nice-modal-react";
import { bffRequester, requester } from "App";
import { mobileNoFormat } from "InitialData/regExp";
import confirm from "antd/lib/modal/confirm";
import Dummy from "components/Dummy";

import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputText from "components/inputs/signUp/InputText";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import ModalBase from "modals/base/ModalBase";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom/dist";
import { toast } from "react-toastify";
import puffuIcon from "resources/img/puffu/puffuIcon.svg";
import biometricService from "shared/BiometricService";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { isAdult } from "shared/utils/Utils";
import { devLog } from "utils/logger";
const NumberVerificationModal = NiceModal.create(props => {
    const { t } = useTranslation();
    const [withHeader, withFooter] = [false, false];
    const [width, height] = ["100%", "60%"];
    const withCloseButton = true;
    const modal = useRef();
    const clickOutsideToClose = false;
    const title = t("");
    const buttonText = t("close");
    const navigate = useNavigate();
    const authNumberRef = useRef();
    const { isMobile } = useContext(BrowserDetectContext);
    const dispatch = useDispatch();
    const clickCountRef = useRef(0);





    const passOnClick = () => {
        dispatch(HistoryReducer.actions.setLoading(true));
        validate();
    }
    const smsOnClick = () => {

        const outerMOKConfirmData = props.data.MOKConfirmData;
        const innerMOKConfirmData = JSON.parse(outerMOKConfirmData);
        if (innerMOKConfirmData.resultCode === "2000") {
            let confirmdata =
            {
                MOKConfirmData: innerMOKConfirmData,
                session: props.token.session,
                authNumber: authNumberRef.current.getValue()
            };

            bffRequester.apiResult(confirmdata, (result) => {


                if (result.resultData) {
                    let mobileDuplicateData = { mobileNumber: props.info.userPhoneNum, storeId: "root", role: "MEMBER" }
                    requester.membermobileNumDuplicate(mobileDuplicateData, (result) => {
                        if (result.code === 0) {
                            if (result.data) {
                                if(isAdult(props.info.userBirthday)){ signIn(); }
                                else{alert( "성인만 이용가능 합니다."); }
                            } else {
                                dispatch(HistoryReducer.actions.setLoading(true));
                                validate(props.info.userBirthday);
                                modal.current.close();
                            }
                        }
                    })

                } else {
                    alert("인증번호를 다시 확인해주세요");
                }
            })
        }

    }

    const validate = (birthDay) => {
        let adultYn = false;
        const outerMOKConfirmData = props.data.MOKConfirmData;

        const innerMOKConfirmData = JSON.parse(outerMOKConfirmData);

        let validateData = {
            MOKConfirmData: innerMOKConfirmData,
            session: props.token.session,
            authNumber: props.authNumber ? props.authNumber : '',
            type: props.type,
            info: props.info
        }

        if (props.type === "PASS") {

            bffRequester.apiResult(validateData, (result) => {

                if (result.resultData) {
                    adultYn = isAdult(result.resultData.userBirthday)
                } else {

                }
                let mobileDuplicateData = { mobileNumber: props.info.userPhoneNum, storeId: "root", role: "MEMBER" }
                if (adultYn) {
                    requester.membermobileNumDuplicate(mobileDuplicateData, (res) => {
                        if (res.data) {

                            signIn();


                        } else {
                            dispatch(HistoryReducer.actions.setLoading(true));
                            signUp(result.resultData.ci, result.resultData.di, result.resultData.userBirthday);
                            modal.current.close();

                        }
                    });

                } else {
                    if (result.resultData) {
                        alert("성인만 가입할 수 있습니다.");
                    } else {
                        clickCountRef.current += 1;
                        if (clickCountRef.current > 3) {
                            alert("처음부터 다시 시도해주세요");
                            // 카운트를 리셋하여 사용자가 처음부터 다시 시도할 수 있게 합니다.
                            clickCountRef.current = 0;
                            // 추가 실행을 막기 위해 함수에서 반환합니다.
                            modal.current.close();
                            return;
                        } else {
                            alert("인증번호를 다시한번 확인해주세요");
                        }
                    }

                }

            })
        } else if (props.type === "SMS") {
            adultYn = isAdult(props.info.userBirthday);
            if (adultYn) {

                signUp(null, null, birthDay);
                // setMobileNumber(props.info.userPhoneNum);
            } else {
                alert("성인만 가입할 수 있습니다.");
                // navigate("/numberSignUp", { replace: true })
                modal.current.close();
            }

        }

    }

    const signIn = async () => {
        let data = { storeId: "root", userName: props.info.userPhoneNum, role: "MEMBER" };

        requester.userNumberSignIn(data, (result) => {
            if (result.code === -1) {
                // 기존 오류 처리 코드
                if (result.message === "Invalid userName") {
                    toast.error(t("noUserName"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                } else if (result.message === "Invalid credentials") {
                    toast.error(t("noPassword"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                } else {
                    toast.error(t("잘못된 연락처"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            } else if (result.code === 0) {
                requester.useYnConfirm(data, async (useYn) => {
                    const isWithdrawn = useYn.data;

                    if (isWithdrawn) {
                        toast.error("탈퇴된 회원입니다.", {
                            autoClose: 1000,
                            position: toast.POSITION.BOTTOM_CENTER
                        });
                    } else {
                        // 사용자 로그인 성공 후 생체인식 등록 상태 확인
                        requester.checkMemberBiometricStatus({ userName: props.info.userPhoneNum }, async (biometricStatus) => {
                            const hasBiometricEnabled = biometricStatus.data?.biometricEnabled;
                            const tokenData = result.data.token;
                            dispatch(AuthReducer.actions.setToken(tokenData));

                            // 휴대폰 번호 저장
                            biometricService.savePhoneNumber(props.info.userPhoneNum);

                            // 생체인증 지원 여부 확인
                            const isBiometricSupported = biometricService.isSupported();

                            // 생체인증을 지원하고, 아직 등록되지 않았거나 재등록이 필요한 경우
                            if (isBiometricSupported && !hasBiometricEnabled) {
                                
                                // 생체인증 안내 모달 표시
                                // 다음과 같이 수정:
                                if (modal && modal.current) {
                                    modal.current.close(); // 현재 모달 닫기
                                } else {
                                    devLog("모달 참조가 없습니다. 닫기 작업을 건너뜁니다.");
                                }

                                NiceModal.show("biometricIntroModal", {
                                    onContinue: async () => {
                                        // 최대 시도 횟수와 현재 시도 횟수 설정
                                        const maxAttempts = 3;
                                        let currentAttempt = 0;
                                        let registrationSuccess = false;

                                        const attemptBiometricRegistration = async () => {
                                            try {
                                                currentAttempt++;
                                                // 사용자 ID로 휴대폰 번호 사용
                                                const userId = props.info.userPhoneNum;

                                                // 생체인증 키 등록 진행
                                                const biometricKeyResult = await biometricService.registerBiometricKey(userId);
                                                

                                                // publicKey 값이 정상적인지 확인
                                                

                                                if (biometricKeyResult && biometricKeyResult.publicKey) {
                                                    
                                                    // 생체인증 정보 업데이트
                                                    const updateData = {
                                                        userName: props.info.userPhoneNum,
                                                        biometricPublicKey: biometricKeyResult.publicKey,
                                                        biometricAlgorithm: biometricKeyResult.algorithm || "EC",
                                                        biometricEnabled: true,
                                                        biometricKeySignature: calculateKeySignature(biometricKeyResult.publicKey),
                                                        biometricPlatform: biometricService.getPlatform()
                                                    };

                                                    // 생체인증 정보 업데이트 API 호출
                                                    requester.checkMemberBiometricStatus(updateData, (updateResult) => {
                                                        if (updateResult.code === 0) {
                                                            
                                                            registrationSuccess = true;
                                                            toast.success("생체인증이 성공적으로 등록되었습니다!", {
                                                                autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
                                                            });

                                                            // 등록 성공 후 메인 페이지로 이동
                                                            proceedToMainPage(tokenData);
                                                        } else {
                                                            
                                                            // 서버 업데이트 실패 시
                                                            if (currentAttempt < maxAttempts) {
                                                                toast.warning("생체인증 정보 저장 중 오류가 발생했습니다. 다시 시도합니다. (" + currentAttempt + "/" + maxAttempts + ")", {
                                                                    autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
                                                                });
                                                                // 잠시 대기 후 재시도
                                                                setTimeout(() => {
                                                                    attemptBiometricRegistration();
                                                                }, 1500);
                                                            } else {
                                                                // 최대 시도 횟수 초과
                                                                toast.error("생체인증 등록에 실패했습니다. 로그인은 완료되었으며, 설정 메뉴에서 나중에 생체인증을 등록할 수 있습니다.", {
                                                                    autoClose: 3000, position: toast.POSITION.BOTTOM_CENTER
                                                                });
                                                                proceedToMainPage(tokenData);
                                                            }
                                                        }
                                                    });
                                                } else {
                                                    // 생체인증 키 생성 실패
                                                    if (currentAttempt < maxAttempts) {
                                                        toast.warning("생체인증 키 생성에 실패했습니다. 다시 시도합니다. (" + currentAttempt + "/" + maxAttempts + ")", {
                                                            autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
                                                        });
                                                        // 잠시 대기 후 재시도
                                                        setTimeout(() => {
                                                            attemptBiometricRegistration();
                                                        }, 1500);
                                                    } else {
                                                        // 최대 시도 횟수 초과
                                                        toast.error("생체인증 등록에 실패했습니다. 로그인은 완료되었으며, 설정 메뉴에서 나중에 생체인증을 등록할 수 있습니다.", {
                                                            autoClose: 3000, position: toast.POSITION.BOTTOM_CENTER
                                                        });
                                                        proceedToMainPage(tokenData);
                                                    }
                                                }
                                            } catch (error) {
                                                // 등록 과정 중 오류 발생
                                                if (currentAttempt < maxAttempts) {
                                                    toast.warning("생체인증 등록 중 오류가 발생했습니다. 다시 시도합니다. (" + currentAttempt + "/" + maxAttempts + ")", {
                                                        autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
                                                    });
                                                    console.error("생체인증 등록 오류:", error);
                                                    // 잠시 대기 후 재시도
                                                    setTimeout(() => {
                                                        attemptBiometricRegistration();
                                                    }, 1500);
                                                } else {
                                                    // 최대 시도 횟수 초과
                                                    toast.error("생체인증 등록에 실패했습니다. 로그인은 완료되었으며, 설정 메뉴에서 나중에 생체인증을 등록할 수 있습니다.", {
                                                        autoClose: 3000, position: toast.POSITION.BOTTOM_CENTER
                                                    });
                                                    console.error("생체인증 최종 등록 실패:", error);
                                                    proceedToMainPage(tokenData);
                                                }
                                            }
                                        };

                                        // 첫 번째 시도 시작
                                        await attemptBiometricRegistration();
                                    },
                                    onSkip: () => {
                                        toast.info("생체인증 등록을 건너뛰었습니다. 설정 메뉴에서 나중에 등록할 수 있습니다.", {
                                            autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
                                        });
                                        proceedToMainPage(tokenData);
                                    }
                                });
                            } else {
                                
                                // 생체인증을 지원하지 않거나 이미 등록된 경우 바로 메인 페이지로 이동
                                proceedToMainPage(tokenData);
                            }
                        });
                    }
                });
            }
        });
    };

    // 웹뷰 처리 및 네비게이션을 위한 헬퍼 함수
    const proceedToMainPage = (tokenData) => {
        // WebView 전송
        setTimeout(() => {
            if (window.webkit?.messageHandlers?.BRIDGE) {
                window.webkit.messageHandlers.BRIDGE.postMessage({ command: "setToken", token: tokenData });
                // 다음과 같이 수정:
                if (modal && modal.current) {
                    modal.current.close(); // 현재 모달 닫기
                } else {
                    devLog("모달 참조가 없습니다. 닫기 작업을 건너뜁니다.");
                }
            }
        }, 500);

        // 네비게이션
        navigate(`/ws/${props.storeCode}/mobile/main`, { replace: true });
        // 다음과 같이 수정:
        if (modal && modal.current) {
            modal.current.close(); // 현재 모달 닫기
        } else {
            devLog("모달 참조가 없습니다. 닫기 작업을 건너뜁니다.");
        }
    };

    const signUp = async (ci, di, birthDay) => {
        dispatch(HistoryReducer.actions.setLoading(true));
    
        try {
            // 기본 회원가입 데이터 준비
            let signUpData = {
                storeId: "root",
                name: props.info.userName,
                mobileNumber: props.info.userPhoneNum,
                ci: ci,
                di: di,
                birthDay: birthDay
            };
            
            // 현재 모달 닫기
            if (modal && modal.current) {
                modal.current.close();
            } else {
                devLog("모달 참조가 없습니다. 닫기 작업을 건너뜁니다.");
            }
            
            // PIN 번호 등록 요청 (네이티브 구현 사용)
            try {
                const pinResult = await biometricService.requestPinRegistration();
                
                if (pinResult && pinResult.success) {
                    // PIN 해시값을 회원가입 데이터에 추가
                    signUpData.pinHash = pinResult.hashedPin || pinResult.pinHash;
                    
                    // 해시값이 JSON 문자열인 경우 파싱
                    if (typeof signUpData.pinHash === 'string' && signUpData.pinHash.startsWith('{')) {
                        try {
                            const pinData = JSON.parse(signUpData.pinHash);
                            signUpData.pinHash = pinData.hashedPin || pinData.pinHash || signUpData.pinHash;
                        } catch (e) {
                            devLog('PIN 해시 파싱 실패, 원본 값 사용', e);
                        }
                    }
                    
                    // 휴대폰 번호 저장
                    biometricService.savePhoneNumber(props.info.userPhoneNum);
                    
                    // 회원가입 바로 진행 (생체인증 모달 표시 없이)
                    proceedWithSignUp(signUpData);
                } else {
                    // PIN 등록 실패 또는 취소 처리
                    toast.error("PIN 번호 등록이 필요합니다. 회원가입을 취소합니다.", {
                        autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
                    });
                    dispatch(HistoryReducer.actions.setLoading(false));
                    navigate("/numberSignUp", { replace: true });
                }
            } catch (error) {
                console.error("PIN 등록 오류:", error);
                toast.error("PIN 번호 등록 중 오류가 발생했습니다. 다시 시도해주세요.", {
                    autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
                });
                dispatch(HistoryReducer.actions.setLoading(false));
                return;
            }
        } catch (error) {
            console.error("회원가입 프로세스 오류:", error);
            toast.error("회원가입 처리 중 오류가 발생했습니다. 다시 시도해주세요.", {
                autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
            });
            dispatch(HistoryReducer.actions.setLoading(false));
        }
    };


    // 공개키 해시 계산
    const calculateKeySignature = (publicKeyBase64) => {
        // 간단한 해시 구현 (실제로는 더 강력한 해시 알고리즘 사용 권장)
        try {
            // Base64 인코딩된 공개키의 앞부분만 사용하여 간단한 서명 생성
            return publicKeyBase64.substring(0, 64);
        } catch (error) {
            console.error("키 시그니처 생성 오류:", error);
            return publicKeyBase64; // 오류 시 원본 키 반환
        }
    };

    // 회원가입 API 호출 함수 분리
    const proceedWithSignUp = (signUpData) => {
        requester.memberNumberSignUp(signUpData, (result) => {
            if (result.code === 0) {
                if (signUpData.biometricEnabled) {
                    toast.success("생체인증이 포함된 회원가입이 완료되었습니다!", {
                        autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
                    });
                } else {
                    toast.success("회원가입이 완료되었습니다!", {
                        autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
                // 회원가입 성공 시 로그인 진행
                signIn();
            } else {
                toast.error(t("회원가입 중 오류가 발생했습니다. 관리자에게 문의하세요"), {
                    autoClose: 2000, position: toast.POSITION.BOTTOM_CENTER
                });
                dispatch(HistoryReducer.actions.setLoading(false));
            }
        });
    };

    



    const btnStyle = {
        width: "100%",
        backgroundColor: "var(--main-color)",
        border: "none",
        height: "48px",
        fontWeight: 700,
        color: "white"
    }

    return (
        <ModalBase
            slideUp
            ref={modal}
            width={width}
            height={height}
            withHeader={withHeader}
            withFooter={withFooter}
            withCloseButton={withCloseButton}
            clickOutsideToClose={clickOutsideToClose}
            title={title}
            buttonText={buttonText}
            overflow={"visible"}
            borderRadius={"25px"}
            onClose={props.onClose}
        >
            {
                props.data &&
                    props.type === "SMS"
                    ?
                    <VerticalFlex gap={10} padding={30} backgroundColor={"white"}>

                        <FlexChild height={"initial"}>
                            <Dummy height={"2vh"} />
                        </FlexChild>
                        <FlexChild height={"initial"}>
                            <Dummy height={"2vh"} />
                            <Center>
                                <P color={"black"} weight={700} size={35}>휴대폰 SMS 인증</P>
                            </Center>
                        </FlexChild>
                        <FlexChild width={"70%"} height={"initial"}>
                            <InputText ref={authNumberRef} id="authNumber" name="authNumber" placeHolder={"인증번호를 입력하세요."} />
                        </FlexChild>
                        <FlexChild>
                            <Center>
                                <CustomButton style={btnStyle} onClick={smsOnClick} text={"인증확인"} />
                            </Center>
                        </FlexChild>
                    </VerticalFlex>
                    :
                    <VerticalFlex gap={10} padding={30} backgroundColor={"white"}>
                        <FlexChild height={"initial"}>
                            <Dummy height={"2vh"} />
                        </FlexChild>
                        <FlexChild>
                            <Center>
                                <P color={"black"} weight={700} size={35}>휴대폰 PASS인증</P>
                                <Dummy height={"10px"} />
                                <P color={"black"} weight={700} size={"4vw"}>PASS인증이 완료되었다면</P>
                                <P size={"4vw"} weight={700} color={"black"}>버튼을 클릭해주세요.</P>
                            </Center>
                        </FlexChild>
                        <FlexChild>
                            <Center>
                                <CustomButton style={btnStyle} onClick={passOnClick} text={"PASS인증완료"} />
                            </Center>
                        </FlexChild>
                    </VerticalFlex>
            }

        </ModalBase>
    );
});

export default NumberVerificationModal;
